import Glide from '@glidejs/glide/dist/glide.modular.esm';
import { addClass } from '@lib/util/dom';
import { loader } from '@lib/lazy';
import { imageLoader } from '@lib/backgroundImageLoader';

export function LazyLoading(glide: Glide, components: any) {
    return {
        mount() {
            addClass(components.Html.root, 'glide--initialized');

            loader.register(
                Array.from((<HTMLElement>components.Html.root)
                    .querySelectorAll<HTMLElement>('.c-lazy-load [data-lazy]'))
            );
            imageLoader.register(
                Array.from((<HTMLElement>components.Html.root)
                    .querySelectorAll<HTMLElement>('.lazy-loader'))
            );
        }
    };
}
